// extracted by css-extract-rspack-plugin
export default {"cls1":"UserListMenu-cls1_e9E","cls2":"UserListMenu-cls2_6ul UserListMenu-cls1_e9E"};